import { useEffect } from 'react';

export const MENU_ICON_SIZE = '1.625rem';
export const VERTICAL_MENU_WIDTH = 250;

/**
 * Simple body scroll lock utilities
 * Provides functions to disable/enable body scrolling
 */
let isDisabled = false;
let scrollPosition = 0;

export function disableBodyScroll() {
  if (isDisabled) return;

  scrollPosition = window.scrollY || document.documentElement.scrollTop;

  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.overflowY = 'scroll';
  document.body.style.width = '100%';

  isDisabled = true;
}

export function enableBodyScroll() {
  if (!isDisabled) return;

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.overflowY = '';
  document.body.style.width = '';

  window.scrollTo(0, scrollPosition);

  isDisabled = false;
}

export function getCurrentScrollPosition() {
  if (isDisabled) {
    return scrollPosition;
  }
  return window.scrollY || document.documentElement.scrollTop;
}

export function useBodyScrollLock(shouldLock) {
  useEffect(() => {
    if (shouldLock) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }

    return () => enableBodyScroll();
  }, [shouldLock]);
}
